import { authorPhotos } from "@/lib/assets";
import { authorHonorificSuffixes, type ArticleDefinition } from "../articleRegistry";

import "../blog.css";

// The registry stores calendar dates; formatting them in UTC keeps a visitor west of Greenwich
// from seeing the day before.
const publishedDate = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
  timeZone: "UTC",
});

type ArticleBylineProps = {
  article: Pick<ArticleDefinition, "author" | "publishedTime">;
};

/** Author photo and name over the publication date. */
export function ArticleByline({ article }: ArticleBylineProps) {
  const photo = authorPhotos[article.author];
  const suffix = authorHonorificSuffixes[article.author];
  return (
    <div className="blog-article-byline">
      {/* The name is printed beside it, so the photo adds nothing for a screen reader. */}
      {photo && <img src={photo} alt="" width={40} height={40} loading="lazy" decoding="async" />}
      <p>
        <span className="blog-article-author">{suffix ? `${article.author}, ${suffix}` : article.author}</span>
        <time dateTime={article.publishedTime}>{publishedDate.format(new Date(article.publishedTime))}</time>
      </p>
    </div>
  );
}
